<template>
  <v-container grid-list-xl>
    <v-form v-model="isAddValid">
      <v-layout row wrap>
        <v-tabs slider-color="grey">
          <v-tab class="tab" :key="1" ripple>Project Info</v-tab>
          <v-tab class="tab" :key="2" ripple>Project Delivery</v-tab>
          <v-tab class="tab" :key="3" ripple>Images</v-tab>
          <v-tab class="tab" :key="4" ripple>Quotes</v-tab>
          <v-tab class="tab" :key="5" ripple>Transport</v-tab>
          <v-tab class="tab" :key="6" ripple>Quote NOtes</v-tab>
          <v-tab-item class="pl-4 pr-4 pt-0 pb-0" :key="1">
            <v-container grid-list-xl>
              <v-layout row wrap>
                <v-flex lg6>
                  <v-switch label="Include for Tendering" v-model="objProjectEdit.incl_tender"></v-switch>
                </v-flex>
                <v-flex lg6>
                  <label class="blackLabel">Tender Closing Date</label>
                  <date-picker v-model="objProjectEdit.tender_closing_date" lang="en"></date-picker>
                </v-flex>
                <v-flex lg6>
                  <label class="blackLabel">* Project Name</label>
                  <v-text-field label="Project Name" :rules="projectNameRules" v-model="objProjectEdit.name" solo></v-text-field>
                </v-flex>
                <v-flex lg6>
                  <label class="blackLabel">Project Code</label>
                  <v-text-field label="Project Code" v-model="objProjectEdit.code" solo></v-text-field>
                </v-flex>
                <v-flex lg6>
                  <label class="blackLabel">Project Reference</label>
                  <v-text-field label="Project Reference" v-model="objProjectEdit.reference" solo></v-text-field>
                </v-flex>
                <v-flex lg6>
                  <label class="blackLabel">* Project Status</label>
                  <v-select :items="projectStatusList" :rules="projectStatusRules" label="Project Status" v-model="objProjectEdit.status" item-value="text" class="dropdown" single-line solo></v-select>
                </v-flex>
                <v-flex lg6>
                  <label class="blackLabel">* Project Type</label>
                  <v-select :items="projectTypeList" :rules="projectTypeRules" label="Project Type" v-model="objProjectEdit.type" item-value="id" class="dropdown" single-line solo></v-select>
                </v-flex>
                <v-flex lg6>
                  <label class="blackLabel">Project Professionals</label>
                  <v-select :items="projectSpecifiers" label="No Specifier Assigned" @input="fncChangeSpecifierType" v-model="objProjectEdit.specifier" item-text="name" item-value="id" class="dropdown" single-line solo>
                    <template slot="item" slot-scope="data">
                      <small v-html="data.item.name"></small>
                    </template>
                  </v-select>
                </v-flex>
              </v-layout>
            </v-container>
          </v-tab-item>
          <v-tab-item class="pl-4 pr-4 pt-4 pb-4" :key="2">
            <v-container grid-list-xl>
              <v-layout row wrap>
                <v-flex lg12 v-if="projectPreLocations.locations.length > 0">
                  <v-switch label="Show predefined address" @change="fncClearAddressSelectors" v-model="projectAddressAlt"></v-switch>
                </v-flex>
                <v-flex lg6 v-if="projectAddressAlt == true">
                  <label class="blackLabel">* Select Location</label>
                  <v-select :items="projectPreLocations.locations" @input="fncSetRegionSub()" label="Select Location" v-model="projectAddressAltVal" item-text="name" class="dropdown" single-line solo></v-select>
                </v-flex>
                <v-flex lg6 v-if="projectAddressAlt == false">
                  <label class="blackLabel">* Select Country</label>
                  <v-select :items="projectRegions" @input="fncSetRegionSub()" label="Select Country" v-model="delCountry" item-text="name" class="dropdown" single-line solo></v-select>
                </v-flex>
                <v-flex lg6 v-if="projectRegionTypes.indexOf('province') !== -1 && projectRegionSub.length != 0 && projectAddressAlt == false">
                  <label class="blackLabel">Select Province</label>
                  <v-select :items="projectRegionSub" @input="fncSetRegionSubSub()" label="Select Province" v-model="delProvince" :disabled="projectRegionSub.length == 0" item-text="name" class="dropdown" single-line solo></v-select>
                </v-flex>
                <v-flex lg6 v-if="projectRegionTypes.indexOf('district') !== -1 && projectRegionSub.length != 0 && projectAddressAlt == false">
                  <label class="blackLabel">Select District</label>
                  <v-select :items="projectRegionSub" @input="fncSetRegionSubSub()" label="Select District" v-model="delDistrict" :disabled="projectRegionSub.length == 0" item-text="name" class="dropdown" single-line solo></v-select>
                </v-flex>
                <v-flex lg6 v-if="projectRegionTypes.indexOf('town') !== -1 && projectRegionTown.length != 0 && projectAddressAlt == false">
                  <label class="blackLabel">Select Town</label>
                  <v-select :items="projectRegionTown" label="Select Town" v-model="delTown" :disabled="projectRegionTown.length == 0" item-text="name" class="dropdown" single-line solo></v-select>
                </v-flex>
                <v-flex lg6>
                  <label class="blackLabel">* Street Name</label>
                  <v-text-field label="Street Name" v-model="delStreetName" solo></v-text-field>
                </v-flex>
                <v-flex lg12>
                  <v-btn color="success" class="text-xs-right" v-if="( delStreetName != '' && delCountry != '') || (delStreetName != '' && projectAddressAltVal != '')" @click.stop="fncAddAddress">Add Address</v-btn>
                  <v-btn color="success" class="text-xs-right" v-else disabled>Add Address</v-btn>
                </v-flex>
                <v-data-table :headers="headers" :items="projectAddresses" v-if="projectAddresses.length > 0" expand hide-actions class="elevation-1 addressList">
                  <template slot="items" slot-scope="props">
                    <tr>
                      <td width="90%" class="text-xs-right">{{ props.item.address_display }}</td>
                      <td width="10%" v-if="objAuthorize.privileges.indexOf('VIEW_PROJECTS') !== -1" class="text-xs-right"><a @click.prevent="fncDeleteAddress(props.item.id)"><i class="material-icons">delete</i></a></td>
                    </tr>
                  </template>
                </v-data-table>
              </v-layout>
            </v-container>
          </v-tab-item>
          <v-tab-item class="pl-4 pr-4 pt-4 pb-4" :key="3">
            <p>Select an image to upload to the project.</p>
            <input type="file" id="projectImg" class="fileUpload" @change="fncSetImageObj">
            <div class="fileHolder">
              <p>Drag & Drop / Click to Add Files</p>
              <small>{{ fileName }}</small>
            </div>
            <v-flex lg12 class=" mt-4 pt-4 projectImageHolder">
              <small class="pt-4 pb-4" v-if="projectEditImages.length == 0">No images have been uploaded to this project</small>
              <v-flex lg3 v-for="( item, key ) in projectEditImages" :key="key" class="imgHolder ml-2 mt-2">
                <img :src="item.source" width="100%" />
                <a href="#" @click.prevent="fncRemoveImage(key)"><i class="material-icons">remove_circle</i></a>
                <label class="blackLabel">Image Caption</label>
                <v-text-field label="Image Caption" v-model="item.caption" solo></v-text-field>
              </v-flex>
            </v-flex>
          </v-tab-item>
          <v-tab-item class="pl-4 pr-4 pt-4 pb-4" :key="4">
            <p v-if="objProjectEdit.quotes.length == 0">No quotes could be found</p>
            <v-data-table :headers="quoteHeaders" :items="objProjectEdit.quotes" v-if="objProjectEdit.quotes.length > 0" expand hide-actions class="elevation-1 addressList">
              <template slot="items" slot-scope="props">
                <tr>
                  <td class="text-xs-right">{{ props.item.quote_date }}</td>
                  <td class="text-xs-right">{{ props.item.quote_no }}</td>
                  <td class="text-xs-right">{{ props.item.customer_name }}</td>
                  <td class="text-xs-right">{{ props.item.pricing_total }}</td>
                  <td class="text-xs-right">{{ props.item.tender_status }}</td>
                  <td class="text-xs-right"><a @click.prevent="fncQuoteAsWinner(props.item.id)"><i class="material-icons">thumb_up</i></a></td>
                  <td class="text-xs-right"><a @click.prevent="fncCancelAdjudication(props.item.id)"><i class="material-icons">thumb_down</i></a></td>
                </tr>
              </template>
            </v-data-table>
          </v-tab-item>
          <v-tab-item class="pl-4 pr-4 pt-4 pb-4" :key="5">
            <p>Select which vehicles must be excluded from transport calculation for this project</p>
            <v-container grid-list-xl>
              <v-layout row wrap>
                <v-flex lg3 v-for="(item, key) in objProjectEdit.prj_vehicles" :key="key">
                  <v-switch v-model="item.excluded" :label="item.name"></v-switch>
                </v-flex>
              </v-layout>
            </v-container>
          </v-tab-item>
          <v-tab-item class="pl-4 pr-4 pt-4 pb-4" :key="6">
            <v-flex xs12>
              <label class="blackLabel">Project Notes</label>
              <v-text-field rows="3" multi-line clearable label="Project Notes" v-model="objProjectEdit.notes" solo></v-text-field>
            </v-flex>
            <v-flex xs12>
              <label class="blackLabel">Site Details</label>
              <v-text-field rows="3" multi-line clearable label="Site Details" v-model="objProjectEdit.site_details" solo></v-text-field>
            </v-flex>
            <v-flex xs12>
              <label class="blackLabel">Contact Details</label>
              <v-text-field rows="3" multi-line clearable label="Contact Details" v-model="objProjectEdit.contact_details" solo></v-text-field>
            </v-flex>
          </v-tab-item>
        </v-tabs>
        <div class="pl-4 pr-4 pb-4 buttonHolder">
          <div style="float: right">
            <v-btn class="text-xs-right cancelButton" @click.stop="fncHideModal">Cancel</v-btn>
            <v-progress-circular indeterminate :width="3" :size="20" color="grey" v-if="userEditSettings" class="pt-3 loginLoader"></v-progress-circular>
            <v-btn color="success" class="text-xs-right" v-if="!userEditSettings" @click.stop="fncUpdateProject">Update</v-btn>
            <!--<v-btn color="success" class="text-xs-right" v-if="!userEditSettings" :disabled="isAddValid == false || projectAddresses.length == 0" @click.stop="fncUpdateProject">Update</v-btn>-->
            <small>* The button will activate once all required fields have been completed</small>
          </div>
        </div>
      </v-layout>
    </v-form>
  </v-container>
</template>

<script>

  import { mapGetters } from 'vuex';
  import DatePicker from 'vue2-datepicker'

  export default {
    name: 'Settings',
    data() {
      return {
        isAddValid: false,
        projectAddressAlt: false,
        headers: [
          { text: 'Address', value: 'address_display', width: "90%" },
          { text: 'Delete', value: 'delete', width: "10%" }
        ],
        quoteHeaders: [
          { text: 'Quote Date', value: 'quote_date' },
          { text: 'Quote No.', value: 'quote_no' },
          { text: 'Customer', value: 'customer_name' },
          { text: 'Total', value: 'pricing_total' },
          { text: 'Tender Status', value: 'tender_status' },
          { text: 'Tender Winner', value: 'tender_winner' },
          { text: 'Cancel Adjudication', value: 'cancel_adjudication' },
        ],
        fileName: '',
        fileObj: '',
        fileArray: [],
        fileCaption: '',
        projectTendering: false,
        projectTenderClosingDate: '',
        projectName: '',
        projectCode: '',
        projectReference: '',
        projectStatus: '',
        projectType: 2,
        projectSpecifier: '',
        projectTypeList: [
          { id: 1, text: 'Government' },
          { id: 2, text: 'Private' },
          { id: 3, text: 'Unknown' }
        ],
        projectNotes: '',
        siteDetails: '',
        contactDetails: '',
        delCountry: [],
        delStreetName: '',
        delProvince: '',
        delDistrict: '',
        delTown: '',
        projectSpecifierType: '',
        projectNameRules: [
          v => !!v || 'Project name is required',
        ],
        projectStatusRules: [
          v => !!v || 'Project status is required',
        ],
        projectTypeRules: [
          v => !!v || 'Project type is required',
        ],
        projectAddresses: this.$store.getters.objProjectEdit.addresses,
        projectAddressAltVal: ''
      };
    },
    methods: {
      fncRemoveImage(key) {
        this.projectEditImages.splice(key, 1);
      },
      fncClearAddressSelectors() {
        this.$store.commit('fncEmptyAddressSelection');
        this.delCountry = '';
        this.projectAddressAltVal = '';
        this.delStreetName = '';
      },
      fncSetImageObj(e) {
        var files = e.target.files[0] || e.dataTransfer.files[0];
        var vm = this;
        if (files.type === 'image/png' || files.type === 'image/jpg' || files.type === 'image/jpeg') {
          this.fileObj = files;
          var currentInput = document.getElementById('projectImg');
          currentInput.value = '';
          this.$store.dispatch('fncUploadEditProjectImage', files);
        } else {
          var snackDetails = { color: 'error', message: 'Please upload either a PNG, JPG or JPEG', display: true };
          this.$store.commit('setSnack', snackDetails);
        }
      },
      fncHideModal() {
        this.$store.commit('hideModal');
      },
      fncSetRegionSub() {
        this.$store.dispatch('fncSetRegionSub', this.delCountry.id);
      },
      fncSetRegionSubSub() {
        var subId = this.delProvince;
        if (this.delDistrict != '') {
          subId = this.delDistrict;
        }
        this.$store.dispatch('fncSetRegionSubSub', subId.id);
      },
      fncDeleteAddress(addressId) {
        var newProjectAddresses = [];
        var n = 1;
        for (var k in this.projectAddresses) {
          if (this.projectAddresses[k].id != addressId) {
            this.projectAddresses[k].id = n;
            newProjectAddresses.push(this.projectAddresses[k]);
            n++;
          }
        }
        this.projectAddresses = newProjectAddresses;
      },
      fncAddAddress() {
        var newId = this.projectAddresses.length + 1;
        if (this.projectAddressAlt == false) {
          var addressDisplay = this.delStreetName;
          if (typeof this.delTown == 'object') {
            addressDisplay = addressDisplay + ', ' + this.delTown.name;
          }
          if (typeof this.delProvince == 'object') {
            addressDisplay = addressDisplay + ', ' + this.delProvince.name;
          }
          if (typeof this.delDistrict == 'object') {
            addressDisplay = addressDisplay + ', ' + this.delDistrict.name;
          }
          if (typeof this.delCountry == 'object') {
            addressDisplay = addressDisplay + ', ' + this.delCountry.name;
          }
          this.projectAddresses.push({
            id: newId,
            regions: {
              country: {
                id: this.delCountry.id,
                name: this.delCountry.name
              },
              province: {
                id: this.delProvince.id,
                name: this.delProvince.name
              },
              district: {
                id: this.delDistrict.id,
                name: this.delDistrict.name
              },
              town: {
                id: this.delTown.id,
                name: this.delTown.name
              },
              suburb: {
                id: '',
                name: ''
              }
            },
            address: this.delStreetName,
            address_display: addressDisplay
          });
        } else {
          var addressDisplay = this.delStreetName + ', ' + this.projectAddressAltVal.name;
          this.projectAddresses.push({
            id: newId,
            regions: {
              country: {
                id: this.projectAddressAltVal.type == 'Country' ? this.projectAddressAltVal.id : 0
              },
              province: {
                id: this.projectAddressAltVal.type == 'Province' ? this.projectAddressAltVal.id : 0
              },
              district: {
                id: this.projectAddressAltVal.type == 'District' ? this.projectAddressAltVal.id : 0
              },
              town: {
                id: this.projectAddressAltVal.type == 'Town' ? this.projectAddressAltVal.id : 0
              },
              suburb: {
                id: this.projectAddressAltVal.type == 'Suburb' ? this.projectAddressAltVal.id : 0
              }
            },
            address: this.delStreetName,
            address_display: addressDisplay
          });
        }
        this.delStreetName = '';
        this.delCountry = '';
        this.delProvince = '';
        this.delDistrict = '';
        this.delTown = '';
        this.projectAddressAltVal = '';
        this.$store.commit('fncEmptyAddressSelection');
      },
      fncChangeSpecifierType() {
        this.projectSpecifierType = this.projectSpecifier.type;
      },
      fncUpdateProject() {
        this.$store.dispatch({
          type: 'fncUpdateProject',
          editObj: this.objProjectEdit,
          addresses: this.projectAddresses,
          images: this.projectEditImages,
          specifierType: this.projectSpecifierType
        })
      },
      fncCancelAdjudication() {
        this.$store.dispatch('fncCancelAdjudication', this.objProjectEdit.id);
      },
      fncQuoteAsWinner(quoteId) {
        this.$store.dispatch({
          type: 'fncQuoteAsWinner',
          quoteId: quoteId,
          projectId: this.globalModalParams.projectId
        })
        //this.$store.dispatch('fncQuoteAsWinner', );
      }
    },
    computed: {
      ...mapGetters([
        'objAuthorize',
        'globalModalParams',
        'userEditSettings',
        'projectStatusList',
        'projectSpecifiers',
        'projectVehicles',
        'projectEditImages',
        'projectRegions',
        'projectRegionTypes',
        'projectRegionSub',
        'projectRegionTown',
        'objProjectEdit',
        'projectPreLocations'
      ])
    },
    created() {
      this.$store.dispatch('fncPopulateProjectStatusList');
      this.$store.dispatch('fncPopulateProjectSpecifiers');
      this.$store.dispatch('fncPopulateProjectVehicles');
      this.$store.dispatch('fncPopulateProjectRegions');
    },
    components: {
      DatePicker
    },
    watch: {
      objProjectEdit() {
      },
      projectTenderWinner() {
        this.projectTenderItems = this.$store.getters.projectTenderWinner;
      }
    }
  }
</script>

<style scoped>
  /*@import './assets/css/shared.css'*/
</style>
